import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './ui-a11y-title.css?inline';

const CName = 'ui-a11y-title';

@customElement(CName)
export class UiA11yTitle extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) level?: 'h1' | 'h2' = 'h1';
  @property({ type: String }) language?: string;

  render() {
    return this.level === 'h1'
      ? html`<h1 class="visually-hidden" lang="${this.language ?? nothing}"><slot></slot></h1>`
      : html`<h2 class="visually-hidden" lang="${this.language ?? nothing}"><slot></slot></h2>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiA11yTitle;
  }
}
